import { createApplicationService } from "./base/applicationServiceBase";
import { AccountsAPI } from "api/axios.config";
import { useMemo } from "react";

const CURRENCIES_BASE = "/Currencies";

const fetchCurrenciesAPI = () => AccountsAPI.get(`${CURRENCIES_BASE}`);

const addNewCurrencyAPI = (data) =>
  AccountsAPI.post(`${CURRENCIES_BASE}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

const updateCurrencyAPI = (id, data) =>
  AccountsAPI.patch(`${CURRENCIES_BASE}/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

const baseService = createApplicationService({
  name: "currencies",
  apiFetchFn: fetchCurrenciesAPI,
  apiAddFn: addNewCurrencyAPI,
  apiUpdateFn: updateCurrencyAPI,
});

const currencyReducer = baseService.reducer;
const getCurrencies = baseService.getData;
const addCurrency = baseService.addData;
const updateCurrency = baseService.updateData;
const useCurrencies = baseService.useData;

const getActiveCurrencies = async () => {
  const currencies = await getCurrencies();
  return currencies.filter((c) => c.active) || [];
};

const useActiveCurrencies = () => {
  const { data, loading } = useCurrencies();
  const activeCurrencies = useMemo(() => data.filter((c) => c.active), [data]);
  return { data: activeCurrencies, loading };
};

export {
  currencyReducer,
  getCurrencies,
  addCurrency,
  updateCurrency,
  getActiveCurrencies,
  useCurrencies,
  useActiveCurrencies,
};
